import { useTranslation } from 'react-i18next'
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface Stats {
  date: string
  visitors: number
  pageviews: number
}

interface Props {
  data: Stats[]
}

export const VisitorChart = ({ data }: Props) => {
  const { t } = useTranslation()
  console.log(data)
  return (
    <div className="mb-10">
      <h3 className="mb-4 text-xl font-bold">{t('Activity')}</h3>
      <ResponsiveContainer width="100%" height="100%" maxHeight={300}>
        <BarChart
          data={data}
          margin={{
            top: 0,
            right: 0,
            left: -40,
            bottom: 0,
          }}
        >
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={(date) =>
              new Date(date).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
              })
            }
          />
          <YAxis />
          <Tooltip />
          <Legend />
          {/* visitors,visits,pageviews,events,bounce_rate */}
          <Bar dataKey="visitors" stackId="a" fill="#8884d8" name="Visitors" />
          <Bar dataKey="visits" stackId="a" fill="#82ca9d" name="Visits" />
          <Bar
            dataKey="pageviews"
            stackId="a"
            fill="#82ca9d"
            name="Page Views"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}